<template>
  <div class="breadcrumbs--wrapper">
    <v-btn icon @click="() => emit('back')" flat color="transparent">
      <v-icon color="primary"> mdi-chevron-left </v-icon>
    </v-btn>
    <div v-for="(item, index) in items" :key="item.text" class="breadcrumbs--item">
      <span
        :class="[
          'breadcrumbs--item--link',
          item.disabled ? 'breadcrumbs--item--link--disabled' : '',
        ]"
        @click="!item.disabled ? handelNavigation(item) : null"
      >
        {{ item.text }}
      </span>
      <span v-if="index < items.length - 1" class="breadcrumbs--item--separator"> / </span>
    </div>
    <div class="breadcrumbs--spacer"></div>
    <AvatarIconMenu small />
  </div>
</template>

<script lang="ts" setup>
import AvatarIconMenu from '@/components/user/profile/AvatarIconMenu.vue';

export interface BreadcrumbsItem {
  text: string
  disabled?: boolean
}

const { items } = defineProps<{ items: BreadcrumbsItem[] }>()

const emit = defineEmits<{
  (e: 'navigation', item: BreadcrumbsItem): void
  (e: 'back'): void
}>()

function handelNavigation(item: BreadcrumbsItem) {
  emit('navigation', item)
}
</script>

<style scoped>
.breadcrumbs--wrapper {
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: row;
  flex-wrap: nowrap;
  padding: 20px;
  overflow: hidden;
}

.breadcrumbs--item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: nowrap;
  min-width: 0;
}

.breadcrumbs--item--separator {
  cursor: default;
  color: rgb(var(--v-theme-pwt_light_grey));
  font-weight: bold;
  padding: 0 10px;
}

.breadcrumbs--item--link {
  flex: 1 1 auto;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 300;
  font-family: "Public Sans", sans-serif;
  min-width: 0;
  padding: 2px 5px;
}

.breadcrumbs--item--link:hover:not(.breadcrumbs--item--link--disabled) {
  background-color: rgb(var(--v-theme-pwt_alabaster));
}

.breadcrumbs--item--link--disabled {
  flex: 1 0 auto;
  cursor: default;
  color: rgb(var(--v-theme-pwt_azure));
  font-weight: 500; 
  font-family: "Public Sans", sans-serif;
  padding: 0 15px;
}

.breadcrumbs--spacer {
  flex: 1 1 auto;
  padding: 0 15px;
}
</style>
